import React from 'react';
import { motion } from 'framer-motion';
import { Eye, ArrowRight } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
const DRILL_OFF_IMAGE = 'https://cdn.magicpatterns.com/uploads/3T4D9d1mqxZRNVtmfCmoc2/Screenshot_2026-05-19_at_13.41.10.png';
const DRILL_ON_IMAGE = 'https://cdn.magicpatterns.com/uploads/nXFdfEaHwLW4gRbrTAP4eJ/Screenshot_2026-05-19_at_13.41.25.png';
export function LayerXRay() {
  return <section className="py-24 bg-solventum-dark" data-id="element-171">
      <div className="max-w-7xl mx-auto px-6" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-173">
          <div className="flex items-center gap-3 mb-4" data-id="element-174">
            <div className="bg-solventum-green text-solventum-dark px-4 py-1 rounded-full text-sm font-bold" data-id="element-175">
              LAYER 3
            </div>
            <Eye className="w-5 h-5 text-solventum-green" data-id="element-176" />
            <span className="text-solventum-lightTeal/60 text-xs tracking-[0.2em] uppercase" data-id="element-177">
              Mobile · Drill Down Toggle
            </span>
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-178">
            The Drill Down Overlay
          </h2>
          <p className="text-xl text-solventum-lightTeal/80 max-w-3xl" data-id="element-179">
            A swipe-up sheet borrowed from premium streaming. Toggle Drill Down
            and the case stays untouched while a layer of context, credentials
            and downloads rises into view.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden ring-1 ring-white/10 bg-gradient-to-br from-[#01403A] via-solventum-dark to-[#011A16] py-16 px-6" data-id="element-180">
          <div className="absolute inset-0 opacity-50" style={{
          backgroundImage: 'radial-gradient(circle at 70% 50%, rgba(5,221,77,0.18) 0%, transparent 55%)'
        }} data-id="element-181" />

          <div className="relative flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-6" data-id="element-182">
            <PhoneStep label="Drill Down off" image={DRILL_OFF_IMAGE} highlight={false} data-id="element-183" />

            <div className="flex flex-col items-center gap-2" data-id="element-184">
              <div className="text-solventum-green text-[10px] font-bold tracking-[0.25em] uppercase" data-id="element-185">
                Tap Drill Down
              </div>
              <div className="w-10 h-10 rounded-full bg-solventum-green/15 ring-1 ring-solventum-green/40 flex items-center justify-center" data-id="element-186">
                <ArrowRight className="w-4 h-4 text-solventum-green hidden lg:block" data-id="element-187" />
                <Eye className="w-4 h-4 text-solventum-green lg:hidden" data-id="element-188" />
              </div>
            </div>

            <PhoneStep label="Drill Down on" image={DRILL_ON_IMAGE} highlight data-id="element-189" />
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center text-solventum-lightTeal/60 mt-12 italic" data-id="element-190">
          The differentiator — rich context, downloadable assets, sales
          enablement signal — without ever disrupting the clinical core.
        </motion.p>
      </div>
    </section>;
}
function PhoneStep({
  label,
  image,
  highlight
}: {
  label: string;
  image: string;
  highlight: boolean;
}) {
  return <div className="relative" data-id="element-191">
      <div className={`absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 text-[10px] font-bold tracking-[0.2em] uppercase rounded-full z-10 whitespace-nowrap ${highlight ? 'bg-solventum-green text-solventum-dark' : 'bg-white/10 backdrop-blur text-white border border-white/10'}`} data-id="element-192">
        {label}
      </div>
      <PhoneFrame className="!w-[240px] sm:!w-[260px]" data-id="element-193">
        <ImageScreen src={image} alt={label} data-id="element-194" />
      </PhoneFrame>
    </div>;
}
function ImageScreen({
  src,
  alt
}: {
  src: string;
  alt: string;
}) {
  return <div className="relative w-full h-full bg-solventum-dark" data-id="element-195">
      <img src={src} alt={alt} className="absolute inset-0 w-full h-full object-contain object-top" data-id="element-196" />
    </div>;
}